<template>
  <LocationCell
    :country="country?.name ?? '-'"
    :country-code="country?.isoCode ?? null"
    :detail="cityDetails"
    :title="country?.name ?? '-'"
    no-icon-fallback
    xs
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { FragmentType, graphql, useFragment } from '@/gql'
import LocationCell from '@/components/LocationCell.vue'

const PaymentRequestWorkLocationColumn = graphql(`
  fragment PaymentRequestWorkLocationColumn on PaymentRequest {
    id
    hire {
      activeContract {
        location {
          city
          state
          country {
            isoCode
            name
          }
        }
      }
    }
  }
`)

const props = defineProps<{
  row: FragmentType<typeof PaymentRequestWorkLocationColumn>
}>()

const column = computed(() => useFragment(PaymentRequestWorkLocationColumn, props.row))

const address = computed(() => column.value.hire?.activeContract?.location)
const country = computed(() => address.value?.country)
const cityDetails = computed(() => {
  const rawCity = address.value?.city ?? ''
  const city = rawCity ? `${rawCity.charAt(0).toUpperCase()}${rawCity.slice(1)}` : ''
  const state = address.value?.state ?? ''
  if (!city && !state) return null
  if (state && city) {
    return `${city}, ${state}`
  }
  return city || state
})
</script>
